// extracted by mini-css-extract-plugin
export default {"attachDocumentsContainer":"AttachDocuments_attachDocumentsContainer__359Ca","buttons":"AttachDocuments_buttons__rxWYe","additionalText":"AttachDocuments_additionalText__BQxct"};